import { MagistralDrugRawMaterial } from '@dreryk/drerykweb-medicine-api';

import { MagistralDrugInitialEditTemplateDetails } from '../../prescriptionTemplates/magistralDrug/MagistralDrugTemplates.types';
import { MedicineRawMaterialTableBean } from '../../shared/formFields/magistralDrug/medicineRawMaterials/MedicineRawMaterialTable.types';

import { MagistralDrugCreateFormBean } from './MagistralDrugCreateForm.types';

export const mapMagistralDrugCreateFormBeanToMagistralDrugTemplate = (
   magistralDrugCreateFormBean: MagistralDrugCreateFormBean
): MagistralDrugInitialEditTemplateDetails => {
   return {
      name: magistralDrugCreateFormBean.drugName ?? undefined,
      additionalDetails: magistralDrugCreateFormBean.additionalDetails ?? undefined,
      form: magistralDrugCreateFormBean.drugForm ?? undefined,
      magistralDrugMedicineRawMaterials:
         magistralDrugCreateFormBean.medicineRawMaterials?.map((material) => ({
            name: typeof material.name === 'string' ? material.name : material.name.nameForPrescription,
            quantityAbbreviation: material.quantityAbbreviation ?? undefined,
            quantity: material.quantity ?? undefined,
            quantityUnit: material.unit === 'NONE' ? undefined : material.unit,
            rpw: material.rpw,
            highDoseAlert: material.excessive,
         })) ?? [],
   };
};

export const mapMagistralDrugRawMaterialToMedicineRawMaterialTableBean = (
   rawMaterial: MagistralDrugRawMaterial
): MedicineRawMaterialTableBean => ({
   name: rawMaterial.name,
   rpw: rawMaterial.rpw,
   excessive: rawMaterial.highDoseAlert,
   quantity: rawMaterial.quantity ?? null,
   quantityAbbreviation: rawMaterial.quantityAbbreviation ?? null,
   unit: rawMaterial.quantityUnit ?? 'NONE',
});
